import { Banner } from '@shared/design-system/ui'

export const COUPON_SCOPE_NOTICE =
  'O cupom é válido somente para a oferta e não se aplica a cobranças recorrentes.'

export function CouponScopeNotice() {
  return (
    <Banner tone="info" title="Informativo">
      {COUPON_SCOPE_NOTICE}
    </Banner>
  )
}
